import React, { useState, lazy } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { ClipboardList, AlertTriangle, Shield, Pill, HeartHandshake, Users, ChevronDown } from 'lucide-react';
const tomos = [{
  num: 1,
  title: 'Evaluación Clínica en Psiquiatría Infantojuvenil',
  icon: ClipboardList,
  img: 'https://images.unsplash.com/photo-1581056771107-24ca5f033842?auto=format&fit=crop&w=900&h=300&q=80',
  content: 'Entrevista con el niño + entrevista con padres + evaluación del desarrollo + EEM adaptada por edad + diagnóstico diferencial en infancia y adolescencia + plantillas listas para completar'
}, {
  num: 2,
  title: 'Crisis y Urgencias en Niños y Adolescentes',
  icon: AlertTriangle,
  img: 'https://images.unsplash.com/photo-1587351021759-3e566b6af7cc?auto=format&fit=crop&w=900&h=300&q=80',
  content: 'Protocolos de actuación rápida, manejo de agitación, riesgo suicida y estabilización en guardia.'
}, {
  num: 3,
  title: 'El Escudo Legal del Psiquiatra Infantojuvenil',
  icon: Shield,
  img: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=900&h=300&q=80',
  content: 'Consentimiento informado, Ley 26.061, responsabilidad profesional y documentación defensiva.'
}, {
  num: 4,
  title: 'Farmacoterapia en Niños y Adolescentes',
  icon: Pill,
  img: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=900&h=300&q=80',
  content: 'Guía de prescripción segura, dosis pediátricas, off-label y comunicación de riesgos a padres.'
}, {
  num: 5,
  title: 'Abuso Infantil: Detección, Denuncia y Protección',
  icon: HeartHandshake,
  img: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=900&h=300&q=80',
  content: 'Indicadores clínicos, obligación de denunciar, preservación de prueba y manejo del secreto médico.'
}, {
  num: 6,
  title: 'Red Institucional: Escuela, Familia y Juzgado',
  icon: Users,
  img: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&h=300&q=80',
  content: 'Informes escolares, respuestas a oficios judiciales, OVD y mediación en conflictos parentales.'
}];
export function TomosAccordion() {
  const [openTomo, setOpenTomo] = useState<number | null>(1);
  return <div className="bg-[#0a1f44] text-white py-8 md:py-16" data-id="element-235">
      <SectionWrapper data-id="element-236">
        <div className="text-center mb-8 md:mb-12" data-id="element-237">
          <p className="text-amber-400 font-bold tracking-wider text-[10px] md:text-xs uppercase mb-2 md:mb-3" data-id="element-238">
            CONTENIDO COMPLETO
          </p>
          <h2 className="text-[22px] md:text-3xl font-extrabold mb-3 md:mb-4 tracking-tight" data-id="element-239">
            LOS 6 TOMOS
          </h2>
          <p className="text-blue-200 max-w-2xl mx-auto text-[14px] md:text-base text-balance" data-id="element-240">
            Tu hoja de ruta clínica y legal para cualquier situación con niños y
            adolescentes
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-2.5 md:space-y-3" data-id="element-241">
          {tomos.map(tomo => {
          const isOpen = openTomo === tomo.num;
          const Icon = tomo.icon;
          return <motion.div key={tomo.num} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'bg-blue-900/60 border-blue-400/50 shadow-lg' : 'bg-blue-900/20 border-blue-800/50 hover:bg-blue-900/40 cursor-pointer'}`} onClick={() => setOpenTomo(isOpen ? null : tomo.num)} data-id="element-242">
                {/* 3:1 Banner */}
                <div className="relative w-full aspect-[3/1] overflow-hidden bg-blue-950" data-id="element-243">
                  <img src={tomo.img} alt={tomo.title} loading="lazy" className="w-full h-full object-cover opacity-90" data-id="element-244" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a1f44] via-[#0a1f44]/60 to-[#0a1f44]/10" data-id="element-245" />
                  <div className="absolute inset-0 flex items-center justify-between px-3.5 md:px-6" data-id="element-246">
                    <div className="flex items-center gap-3 md:gap-4" data-id="element-247">
                      <div className={`w-9 h-9 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0 transition-colors backdrop-blur-sm ${isOpen ? 'bg-orange-500 text-white shadow-inner' : 'bg-blue-900/70 text-blue-100'}`} data-id="element-248">
                        <Icon className="w-4 h-4 md:w-5 md:h-5" data-id="element-249" />
                      </div>
                      <div data-id="element-250">
                        <p className="text-[10px] md:text-xs font-bold text-amber-300 uppercase tracking-wider mb-0.5 md:mb-1 drop-shadow" data-id="element-251">
                          Tomo {tomo.num}
                        </p>
                        <h3 className="font-bold text-[13px] md:text-lg leading-tight text-white drop-shadow max-w-[200px] md:max-w-md" data-id="element-252">
                          {tomo.title}
                        </h3>
                      </div>
                    </div>
                    <ChevronDown className={`w-5 h-5 text-white/80 transition-transform duration-300 shrink-0 ml-2 ${isOpen ? 'rotate-180 text-orange-400' : ''}`} data-id="element-253" />
                  </div>
                </div>

                <AnimatePresence data-id="element-254">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-255">
                      <div className="px-4 py-4 md:px-6 md:py-5 text-blue-100/90 text-[13px] md:text-sm leading-relaxed" data-id="element-256">
                        {tomo.content}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </SectionWrapper>
    </div>;
}